import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { LayoutLogin } from '../layouts/LoginLayout';
import { useSearchParams } from 'react-router-dom';
import { API_URL } from '../config';

const TurnoCard = ({ casilla, historico, handleDescartar }) => {
  const isDifferent = casilla.folio !== historico.find((h) => h.folio === casilla.folio)?.folio;
  const ultimo = isDifferent && casilla.estado === 'ocupado'
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
          height: '180px',
          borderRadius: '20px',
          backgroundColor: casilla.estado === 'libre' ? 'grey.500' : 'primary.main',
          //backgroundImage: casilla.estado === 'libre' ? 'none' : 'linear-gradient(0deg, rgba(0, 213, 255, 0.64) 20%, #83a4d4 80%, #83a4d4 100%)',
          position: 'relative',
          border: ultimo ? '5px solid #BC955B' : 'none',
        }}
      >
        <Typography
          variant="h5"
          color="primary.white"
          fontWeight={500}
        >
          Estación {casilla.casilla}
        </Typography>
        <CardContent>
          <Typography variant="h3" color="primary.white" fontWeight={500}>
            {casilla.folio || 'Libre'}
          </Typography>
        </CardContent>
        {casilla.estado === 'ocupado' && (
          <Box
            onClick={() => {
              if (casilla.estado === 'ocupado') {
                handleDescartar(casilla.folio);
              }
            }}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              position: 'absolute',
              bottom: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              borderBottomLeftRadius: '20px',
              borderBottomRightRadius: '20px',
              padding: '5px',
              height: '40px',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <Typography
              variant="caption"
              color="primary.white"
            >
              Descartar turno
            </Typography>
          </Box>
        )}
      </Card>

      {ultimo && (
        <Typography
          variant="caption"
          color="primary.black"
        >
          Último en atención
        </Typography>
      )}
    </Box>
  );
};

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const [atencion, setAtencion] = useState([]);
  const [historico, setHistorico] = useState([]);

  const getTurnos = async () => {
    try {
      const response = await fetch(`${API_URL}/turnos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ rol: 'Signos' }),
      });
      const data = await response.json();

      setAtencion(data.atencion);
      setHistorico(data.historico);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDescartar = async (folio) => {
    try {
      await fetch(`${API_URL}/turnos/release/turn`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          folio: folio,
          rol: "Signos"
        }),
      });
      // Actualizar la ventana despues de 2 segundos
      setTimeout(() => {
        getTurnos();
      }, 2000);
      getTurnos();
    } catch (error) {
      console.error(error);
    }
  }


  //UseEffect para obtener los turnos cada 10 segundos
  useEffect(() => {
    getTurnos();
    const interval = setInterval(() => {
      getTurnos();
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);


  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        minHeight: '100vh',
        width: '100%',
        p: 5,
      }}
    >
      <Typography variant="h2" color="primary.black" fontWeight={500} my={2}>
        Administrador de turnos de Signos Vitales
      </Typography>
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexDirection: 'column',
          borderRadius: '20px',
          p: 1,
          backgroundColor: 'primary.main',
        }}
      >
        <Typography
          variant="h5"
          color="primary.white"
        >
          Turnos en proceso
        </Typography>
      </Card>

      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          mt: 2
        }}
      >
        {atencion.map((casilla) => (
          <Grid
            item
            xs={12}
            md={type === 's' ? 2.4 : 2.4}
            key={casilla.id}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <TurnoCard
              casilla={casilla}
              historico={historico}
              handleDescartar={handleDescartar}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const TurnosAdminSignos = () => {
  return (
    <LayoutLogin>
      <HomePage />
    </LayoutLogin>
  );
};

export default TurnosAdminSignos;
